module.exports = __webpack_public_path__ + "static/media/republican.50100d70.svg";